import {useEffect, useState} from "react";
import * as XLSX from 'xlsx';
import {DefaultFileUpload} from "../file/DefaultFileUpload.tsx";
import {HelpUtil} from "@/util/HelpUtil.ts";
import {useDispatch, useSelector} from "react-redux";
import {attribute} from "@/store/modules/attribute.ts";
import {CreateBulkAttributeRequest} from "@/model/request/attribute/CreateBulkAttributeRequest.ts";
import {TailSpin} from "react-loader-spinner";
import {RootState} from "@/store";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {ModalType} from "./NewApplicationModal.tsx";
import {BaseResponse} from "@/model/response/BaseResponse.ts";


function BulkUploadModalNew({show, onClose}: ModalType) {
    const [fileName, setFileName] = useState("");
    const [fileData, setFileData] = useState<CreateBulkAttributeRequest>([]);
    const attributeState = useSelector((state: RootState) => state.attribute);
    const entityState = useSelector((state: RootState) => state.entity);
    const dispatch = useDispatch<any>()

    const fileUrl = "/file/Book2.xlsx";

    const showMessage = (response: any) => {
        StoreUtil.execute(() => {
                dispatch(
                    notification.mutation.openModal({
                        type: "success",
                        title: "Success",
                        body: response.responseMessage,
                    })
                )
                dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState?.selectedEntity?.entityId ? entityState?.selectedEntity?.entityId : 0}))
            }
        );
        onClose()
    };

    const showErrorMessage = (response: BaseResponse) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };

    // const handleDownloadTemplate = () => {
    //     const templateUrl = "../../../public/file/Book2.xlsx";
    //     window.location.href = templateUrl;
    // };

    const handleDownload = () => {
        const link = document.createElement("a");
        link.href = fileUrl;
        link.download = "template.xlsx";
        link.target = "_blank"
        link.click();
        link.remove();
    };

    useEffect(() => {
        if (show) {
            setFileData([]);
        }
    }, [show]);

    console.log(fileData)


    // const onExcelUpload = (file: any) => {
    //     const reader = new FileReader();
    //     reader.onload = (e) => {
    //         const result = e.target?.result;
    //         let data
    //         if (result) {
    //             data = new Uint8Array(result as ArrayBuffer);
    //             // console.log(data);
    //         } else {
    //             console.error("File read error");
    //         }
    //         const workbook = XLSX.read(data, {type: 'array'});
    //         const sheetName = workbook.SheetNames[0];
    //         const worksheet = workbook.Sheets[sheetName];
    //         const json = XLSX.utils.sheet_to_json(worksheet) as unknown as CreateBulkAttributeRequest;
    //         console.log(json)
    //         setFileData(json)
    //         // action && action(json)
    //         // setPreview(null)
    //         // HelpUtil.modalFunction(ModalConstant.importModal).close()
    //     };
    //     reader.readAsArrayBuffer(file);
    // };

    const onExcelUpload = (file: File) => {
        const reader = new FileReader();

        reader.onload = (e) => {
            const result = e.target?.result;

            if (result) {
                const data = new Uint8Array(result as ArrayBuffer);

                // Read the workbook
                const workbook = XLSX.read(data, {type: 'array'});

                const sheetName = workbook.SheetNames[0];
                const worksheet = workbook.Sheets[sheetName];

                // Convert the sheet to JSON and store it as an array
                const jsonData = XLSX.utils.sheet_to_json(worksheet) as unknown as CreateBulkAttributeRequest;


                // Update the fileData state with the array
                setFileData(() => [...jsonData]); // Ensure a fresh state update
                console.log('Extracted Data:', jsonData); // Verify the data in console

            } else {
                console.error("File read error");
            }
        };

        reader.readAsArrayBuffer(file);
    };


    const onCsvUpload = (file: any) => {
        const reader = new FileReader();
        reader.onload = (e) => {
            const text = e.target?.result
            const data = HelpUtil.parseCSV(text) as unknown as CreateBulkAttributeRequest;
            console.log(data)
            setFileData(data)
            // action && action(data)
            // setPreview(null)
            // HelpUtil.modalFunction(ModalConstant.importModal).close()
        };
        reader.readAsText(file);
    };
    useEffect(() => {
        setFileName("")
    }, [show]);

    // const showMessage = (
    //     response: any,
    //     title: "error" | "success" = "success",
    //     type: "error" | "success" = "success"
    // ) => {
    //     StoreUtil.execute(() => {
    //             dispatch(
    //                 notification.mutation.openModal({
    //                     type: type,
    //                     title: title,
    //                     body: response.responseMessage,
    //                 })
    //             )
    //             dispatch(attribute.action.readAttributeByEntityId({attributeEntityId: entityState.selectedEntity?.entityId}))
    //         }
    //     );
    //     onClose()
    // };

    // const onDrop = (acceptedFiles: any) => {
    //     if (acceptedFiles.length > 0) {
    //         setFileName(acceptedFiles[0].name);
    //     }
    // };
    //
    // const {getRootProps, getInputProps} = useDropzone({
    //     onDrop,
    //     accept: {
    //         "text/csv": [".csv"],
    //         "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
    //         "application/vnd.ms-excel": [".xls"]
    //     }
    // });

    const handleOnSubmit = () => {
        const updatedFileData = fileData.map(it => ({
            ...it,
            attributeEntityId: entityState.selectedEntity.entityId,
            attributeReferenceEntity: entityState.selectedEntity.entityName
        }))
        dispatch(attribute.action.bulkCreate({
                data: updatedFileData,
                onSuccess: (response: BaseResponse) => showMessage(response),
                onError: (response: BaseResponse) => showErrorMessage(response)
            })
            // setFileData([])
        )
    }


    const handleOnChange = (value: File) => {
        console.log(value.name)
        if (value.name?.includes('.csv')) {
            setFileName(value.name);
            onCsvUpload(value)
        } else {
            setFileName(value.name);
            onExcelUpload(value)
        }
    }

    return (
        <>
            {show &&
                <div className="modal1_component">
                    <div className="modal1_content-wrapper modal1_background-overlay">
                        <div className="bulk-modal">
                            <div className="modal-head ">
                                <h5>Upload File</h5>
                                <i className=" text-4xl bx bx-x" onClick={onClose}></i>
                            </div>
                            <div className="download cursor-pointer">
                                <i className="bx bx-download text-orange-500 text-xl"></i>
                                <span className="underline text-orange-500"
                                      onClick={handleDownload}>Download Template</span>
                            </div>
                            <DefaultFileUpload types={['xlsx', 'csv']}
                                               onChangeFile={handleOnChange}>
                                {fileName && (
                                    <p>
                                        <strong>Selected file:</strong> {fileName}
                                    </p>
                                )}

                                {/*</div>*/}
                            </DefaultFileUpload>
                            <div className={"flex gap-3 justify-end"}>
                                <button className="button" onClick={handleOnSubmit} disabled={fileData.length == 0}>
                                    {attributeState.loading ?
                                        <p style={{margin: "auto", marginTop: "15px"}}>
                                            <TailSpin visible={true} height={30} width={30} color="#ec9c3f"
                                                      ariaLabel="tail-spin-loading" strokeWidth={5}
                                                      wrapperStyle={{}}
                                                      wrapperClass=""
                                            />
                                        </p>
                                        : "Upload"}
                                </button>
                                <button className="button is-secondary" onClick={onClose}>Cancel</button>
                            </div>


                            {/*</Modal>*/}
                        </div>
                    </div>
                </div>
            }
        </>

    );
}

export default BulkUploadModalNew;
